import { render } from "./MeteringSystemsTable.vue?vue&type=template&id=20f89a5b&scoped=true"
import script from "./MeteringSystemsTable.vue?vue&type=script&lang=js"
export * from "./MeteringSystemsTable.vue?vue&type=script&lang=js"

import "./MeteringSystemsTable.vue?vue&type=style&index=0&id=20f89a5b&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src804629530/src/be-admin-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f89a5b"]])

export default __exports__